module.exports = __webpack_public_path__ + "images/password-reset-da3d100a.png";